document.addEventListener('DOMContentLoaded', function () {
  var chips = document.querySelectorAll('.size-chip:not(:disabled)');
  if (!chips.length) return;

  function syncSelectedState() {
    document.querySelectorAll('.size-chip').forEach(function (chip) {
      chip.classList.toggle('size-chip--selected', chip.classList.contains('active'));
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var group = chip.closest('.size-selector__chips');
      if (!group) return;

      group.querySelectorAll('.size-chip').forEach(function (c) {
        c.classList.remove('size-chip--selected');
      });

      chip.classList.add('size-chip--selected');
    });
  });

  syncSelectedState();
});
